function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ReactDOM from 'react-dom';
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal, faPercent, faMapMarkerAlt, faMapMarkedAlt, faFlagUsa, faTrophy } from '@fortawesome/free-solid-svg-icons';
import LogBookEntry from '../../../model/LogBookEntry';
import RiderStat from './RiderStat';
import LoadingIndicator from '../../LoadingIndicator';
import './RiderResult.css'; // Points tables based on 2020 Rulebook

var NOVICE_TABLE = [0, 25, 20, 15, 12, 10, 7, 5, 3];
var INTERMEDIATE_TABLE = [0, 50, 40, 30, 25, 20, 15, 10, 5];
var EXPERT_TABLE = [0, 100, 80, 60, 50, 40, 30, 20, 10];
var STATE_GOLDCUP_NOVICE_TABLE = [10, 18, 17, 16, 15, 14, 13, 12, 11];
var STATE_GOLDCUP_INTERMEDIATE_TABLE = [10, 19, 18, 17, 16, 15, 14, 13, 12];
var STATE_GOLDCUP_EXPERT_TABLE = [10, 20, 19, 18, 17, 16, 15, 14, 13, 12, 13];
var NATIONAL_NOVICE_TABLE = [0, 60, 50, 40, 30, 20, 10, 8, 5];
var NATIONAL_INTERMEDIATE_TABLE = [0, 120, 100, 80, 60, 40, 20, 15, 10];
var NATIONAL_EXPERT_TABLE = [0, 240, 200, 160, 120, 80, 40, 30, 20]; // whats important about the result? the rider, date, class, race name, location, whether or not its posted, poduium or win?

var RiderResult = /*#__PURE__*/function (_React$Component) {
  _inherits(RiderResult, _React$Component);

  function RiderResult(props) {
    var _this;

    _classCallCheck(this, RiderResult);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RiderResult).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "retrieveRiderData", function () {
      var currentYear = new DateTime.fromJSDate(new Date()).year;
      var _this$props = _this.props,
          storage = _this$props.storage,
          rider = _this$props.rider;
      var classDistrictPoints = 0;
      var classNationalPoints = 0;
      var classStatePoints = 0;
      var classGoldCupPoints = 0;
      var cruiserDistrictPoints = 0;
      var cruiserNationalPoints = 0;
      var cruiserStatePoints = 0;
      var cruiserGoldCupPoints = 0;
      var wins = 0;
      var totalRaces = 0;
      LogBookEntry.forRider(storage, rider.id).then(function (entries) {
        entries.filter(function (e) {
          return e.pointsClass.id !== 0 && e.date.year === currentYear;
        }).forEach(function (logBookEntry) {
          var pointsClass = logBookEntry.pointsClass,
              riderEntries = logBookEntry.riderEntries,
              category = logBookEntry.category;
          var isNational = category === 'National';
          var isState = category === 'State';
          var isGoldCup = category === 'Gold Cup'; // TOOO: Multi Points for GC / STATE Finals
          // Bonus Points

          riderEntries.filter(function (e) {
            return e.rider.id === rider.id;
          }).forEach(function (entry) {
            var ageGroup = entry.ageGroup;
            var totalRiders = 0;

            try {
              totalRiders = parseInt(entry.totalRiders);
            } catch (error) {}

            if (isNaN(totalRiders)) {
              totalRiders = 0;
            }

            totalRaces++;
            var main = entry.motos.find(function (moto) {
              return moto.name === 'main';
            });
            var finish = main.finish === '' || main.finish === null || main.finish === undefined ? 0 : parseInt(main.finish);

            if (finish === 1) {
              wins++;
            }

            if (!ageGroup || ageGroup.trim() === '' || ageGroup.toLowerCase().indexOf('open') > -1) {
              return;
            }

            var pointsGroup = ageGroup.toLowerCase(); // Based on 2020 Rulebook

            if (pointsGroup.indexOf('cruiser') > -1) {
              if (isNational) {
                cruiserNationalPoints += NATIONAL_EXPERT_TABLE[finish] + totalRiders;
              }

              if (isState) {
                cruiserStatePoints += STATE_GOLDCUP_EXPERT_TABLE[finish];
              }

              if (isGoldCup) {
                cruiserGoldCupPoints += STATE_GOLDCUP_EXPERT_TABLE[finish];
              }

              cruiserDistrictPoints += (EXPERT_TABLE[finish] + totalRiders) * pointsClass.id;
            } else {
              var pointsTable;
              var nationalPointsTable;
              var stateGoldCupTable;

              if (pointsGroup.indexOf('women') > -1 || pointsGroup.indexOf('girl') > -1 || pointsGroup.indexOf('expert') > -1) {
                pointsTable = EXPERT_TABLE;
                nationalPointsTable = NATIONAL_EXPERT_TABLE;
                stateGoldCupTable = STATE_GOLDCUP_EXPERT_TABLE;
              } else if (pointsGroup.indexOf('intermediate')) {
                pointsTable = INTERMEDIATE_TABLE;
                nationalPointsTable = NATIONAL_INTERMEDIATE_TABLE;
                stateGoldCupTable = STATE_GOLDCUP_INTERMEDIATE_TABLE;
              } else {
                pointsTable = NOVICE_TABLE;
                nationalPointsTable = NATIONAL_NOVICE_TABLE;
                stateGoldCupTable = STATE_GOLDCUP_NOVICE_TABLE;
              }

              if (isNational) {
                classNationalPoints += nationalPointsTable[finish] + totalRiders;
              }

              if (isState) {
                classStatePoints += stateGoldCupTable[finish];
              }

              if (isGoldCup) {
                classGoldCupPoints += stateGoldCupTable[finish];
              }

              classDistrictPoints += (pointsTable[finish] + totalRiders) * pointsClass.id;
            }
          });
        });
        var winPercentage = Math.round((wins / totalRaces * 100 + Number.EPSILON) * 10) / 10;

        _this.setState({
          wins: wins,
          winPercentage: winPercentage,
          classDistrictPoints: classDistrictPoints,
          classNationalPoints: classNationalPoints,
          cruiserDistrictPoints: cruiserDistrictPoints,
          cruiserNationalPoints: cruiserNationalPoints,
          classStatePoints: classStatePoints,
          classGoldCupPoints: classGoldCupPoints,
          cruiserStatePoints: cruiserStatePoints,
          cruiserGoldCupPoints: cruiserGoldCupPoints
        });
      });
    });

    _this.state = {};
    return _this;
  }

  _createClass(RiderResult, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.retrieveRiderData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.logBookEntryId !== prevProps.logBookEntryId) {
        this.retrieveRiderData();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          width = _this$props2.width,
          height = _this$props2.height,
          rider = _this$props2.rider;
      var _this$state = this.state,
          wins = _this$state.wins,
          winPercentage = _this$state.winPercentage,
          classDistrictPoints = _this$state.classDistrictPoints,
          classStatePoints = _this$state.classStatePoints,
          classGoldCupPoints = _this$state.classGoldCupPoints,
          classNationalPoints = _this$state.classNationalPoints,
          cruiserDistrictPoints = _this$state.cruiserDistrictPoints,
          cruiserNationalPoints = _this$state.cruiserNationalPoints,
          cruiserStatePoints = _this$state.cruiserStatePoints,
          cruiserGoldCupPoints = _this$state.cruiserGoldCupPoints;
      var loading = wins === undefined;
      return React.createElement("div", {
        className: "rider-result",
        style: {
          width: "".concat(width, "px"),
          height: "".concat(height, "px")
        }
      }, React.createElement("div", {
        className: "name"
      }, rider.name), !loading && React.createElement("div", {
        className: "stats"
      }, React.createElement("div", {
        className: "stats-row"
      }, React.createElement(RiderStat, {
        icon: faMedal,
        label: 'wins',
        value: wins
      }), React.createElement(RiderStat, {
        icon: faPercent,
        label: 'win percentage',
        value: isNaN(winPercentage) ? 0 : winPercentage
      })), React.createElement("div", {
        className: "divider"
      }, "class"), React.createElement("div", {
        className: "stats-row"
      }, React.createElement(RiderStat, {
        icon: faMapMarkerAlt,
        label: 'district points',
        subtitle: 'class',
        value: classDistrictPoints
      }), React.createElement(RiderStat, {
        icon: faFlagUsa,
        label: 'national points',
        subtitle: 'class',
        value: classNationalPoints
      })), React.createElement("div", {
        className: "stats-row"
      }, React.createElement(RiderStat, {
        icon: faMapMarkedAlt,
        label: 'state points',
        subtitle: 'class',
        value: classStatePoints
      }), React.createElement(RiderStat, {
        icon: faTrophy,
        label: 'gold cup points',
        subtitle: 'class',
        value: classGoldCupPoints
      })), React.createElement("div", {
        className: "divider"
      }, "cruiser"), React.createElement("div", {
        className: "stats-row"
      }, React.createElement(RiderStat, {
        icon: faMapMarkerAlt,
        label: 'district points',
        subtitle: 'cruiser',
        value: cruiserDistrictPoints
      }), React.createElement(RiderStat, {
        icon: faFlagUsa,
        label: 'national points',
        subtitle: 'cruiser',
        value: cruiserNationalPoints
      })), React.createElement("div", {
        className: "stats-row"
      }, React.createElement(RiderStat, {
        icon: faMapMarkedAlt,
        label: 'state points',
        subtitle: 'class',
        value: cruiserStatePoints
      }), React.createElement(RiderStat, {
        icon: faTrophy,
        label: 'gold cup points',
        subtitle: 'class',
        value: cruiserGoldCupPoints
      }))));
    }
  }]);

  return RiderResult;
}(React.Component);

export default RiderResult;